<script>
import TitlePage from "@/components/title-page"
import appConfig from "@/app.config";
import { StoreMerchantService } from "@/services/nextshop/storeMerchant.service"

export default {
  name: "product-detail",
  page: {
    title: "Chi tiết sản phẩm",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { TitlePage },
  data() {
    return {
      dataPermission: JSON.parse(localStorage.getItem("dataPermission")),
      inforMerchant: JSON.parse(localStorage.getItem("auth.currentMerchant")),
      inforAccount: JSON.parse(localStorage.getItem("auth.currentUser")),
      loading: false,
      isShowData: false,
      checkUndefined: false,
      title: "CHI TIẾT SẢN PHẨM",
      items: [
        { text: "Gian hàng trực tuyến",
          href: JSON.parse(localStorage.getItem("dataPermission")) && JSON.parse(localStorage.getItem("dataPermission")).includes('NSH_ONLINE_STORE_VIEW') ?
           "/store-merchant/product-list" : "#"
        },
        {
          text: "Chi tiết sản phẩm",
          active: true
        }
      ],
      idProduct: this.$route.params.id,
      quantity: 1, 

      dataProduct: {
        category: {
          name: ""
        },
        metaSearchable: {
          madeBy: ""
        }
      },

      dataVariations: [],

      dataVariationMin: {
        images: [],
        prices: [
          {
            amount: 0
          }
        ],
        options: [
          {
            values: []
          }
        ]
      },
      images: [],
      hasImage: false,
      activeImg: 0
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    imageShow(event) {
      const image = event.target.src;
      const expandImg = document.getElementById("expandedImg");
      expandImg.src = image;
    },

    sleep(ms) {
      return new Promise(resolve => {
        setTimeout(resolve, ms);
      });
    },
    
    async fetchData() {
      try {
        this.loading = true
        const response = await StoreMerchantService.getProductDetail(this.idProduct)
        const variationPrices = []
        if ( response.status === 200 ) {
          this.dataProduct = response.data
          if (response.data.images.length > 0 && response.data.images[0] != "") {
            this.hasImage = true;
            this.images = [...response.data.images];
          }
      
          this.dataVariations = response.data.variations.map((e) => {
              let tmpPrice = 0
              const getPriceItem = e.prices.find(price => price.priceTypeCode === 'PRICE_EXPORT')
              if(getPriceItem != undefined){
                tmpPrice = (e.prices.length === 0) ? 0 : this.divisionThousand(getPriceItem.amount)
                variationPrices.push(tmpPrice)
              }
              return {
                ...e,
                prices: [
                  {
                    amount: (e.prices.length === 0) ? 0 : tmpPrice,
                    itemPriceId: e.itemPriceId || '',
                    currency: "VND",
                    version: e.version,
                    priceTypeCode: "PRICE_EXPORT",
                  }
                ]
              }
          })

          this.dataVariations.push({
            images: [],
            name: "",
            options: this.dataProduct.options.map(e => {
              e.selected = "";
              e.valuesArr = [];
              e.values.forEach((item) => {
                e.valuesArr.push({ name: item, disabled: false });
              });

              return {
                ...e,
                values: []
              }
            }),
            prices: [{
              amount: 0,
            }],
          })

          const indexVariationMin = await this.getVariationMin(variationPrices)
          this.dataVariationMin = this.dataVariations[indexVariationMin]
          if ( !this.dataProduct.metaSearchable.madeBy && !this.dataProduct.metaSearchable.brand ) {
            this.dataProduct.metaSearchable = {
              ...this.dataProduct.metaSearchable,
              brand: "",
              madeBy: ""
            }
          }
          this.isShowData = true
          this.loading = false
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getVariationMin(variationPrices) {
      let variationMin = Math.min.apply(Math, variationPrices);
      return variationPrices.indexOf( variationMin )
    },

    copyURL() {
      navigator.clipboard.writeText(`${process.env.VUE_APP_STORE_ONLINE}/store/${this.inforMerchant.aliasName}/${this.idProduct}`);
      this.$bvToast.toast(`Sao chép liên kết thành công!`, {
        title: `Thông báo`,
        autoHideDelay: `1000`,
        variant: `success`,
        toaster: `b-toaster-top-center`,
        solid: true,
        appendToast: true,
      });
    },

    changeVariation(val, indexVal) {
      const arrVals = []
      const arrValVariationMin = this.dataVariationMin.options.map(e => e.values[0])
      const arrOpsVal = this.dataVariations.map(e => e.options)

      arrValVariationMin.splice(indexVal, 1, val)
      for (let i = 0; i < arrOpsVal.length; i++) {
        const arrValOps = arrOpsVal[i].map(e => e.values[0])
        arrVals.push(arrValOps)
      }

      const index = arrVals.findIndex(e => JSON.stringify(e) === JSON.stringify(arrValVariationMin))
      if (index != -1 && this.dataVariations[index].variationId) {
        this.dataVariationMin = this.dataVariations[index]
        this.checkUndefined = false
      } else {
        this.checkUndefined = true
        this.dataVariationMin = this.dataVariations[this.dataVariations.length - 1]
        const dataChange = this.dataVariationMin.options.map((e, index) => {
          return {
              ...e,
              values: [arrValVariationMin[index]]
          }
        })
              
        this.dataVariationMin.options = dataChange

        this.$bvToast.toast(`Sản phẩm này đã hết hàng!`, {
          title: `Thông báo`,
          autoHideDelay: `000`,
          variant: `danger`,
          toaster: `b-toaster-top-center`,
          solid: true,
          appendToast: true,
        });
      }
      this.quantity = 1   
    },
    onClickImg(index) {
      this.activeImg = index;
      this.$refs.elCarousel.setActiveItem(index);
      this.$refs.imageList.childNodes[index].scrollIntoView({ behavior: "smooth", block: "nearest" });
    },
    changeSlide(newValue) {
      this.onClickImg(newValue);
    },
  }
};
</script>

<template>
  <TheLayout>
    <div v-if="dataPermission && dataPermission.includes('NSH_ONLINE_STORE_VIEW')">
      <div class="box-loading" v-if="loading">
        <div class="loading">
          <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
        </div>
      </div>

      <div v-if="isShowData">
        <TitlePage :title="title" :items="items" />

        <div class="row mb-3">
          <div class="col-lg-12 ">
            <div class="d-flex justify-content-between">
              <b-button variant="outline-primary" class="btn-primary-custom" @click="copyURL()">
                <i class="bx bx-share-alt"></i>
                Sao chép liên kết
              </b-button>

              <b-button variant="primary" @click="$router.push({ path: `/items/items-detail/${idProduct}` })"
              v-if="dataPermission && dataPermission.includes('NSH_ITEM_PROD_UPDATE')">
                <i class="bx bx-edit"></i>
                Chỉnh sửa sản phẩm
              </b-button>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-xl-5">
                    <div class="product-detai-imgs">
                      <div class="row d-column">
                      <div class="col-md-2 col-12">
                        <div class="w-100 h-100 _product-sm-img" ref="imageList">
                          <span v-for="(item, i) in images" :key="i" @click="onClickImg(i)">
                            <img v-if="hasImage" :class="activeImg === i ? 'active' : ''" :src="item" :alt="item" />
                            <img v-else alt="item" :key="i" src="@/assets/images/no-img.png" />
                          </span>
                        </div>
                      </div>
                      <div class="col-md-10 col-12">
                        <el-carousel v-if="hasImage" ref="elCarousel" height="480px" :autoplay="false" trigger="click" indicator-position="none" @change="changeSlide">
                          <el-carousel-item v-for="(item, i) in images" :key="i">
                            <img class="w-100 h-100" style="object-fit: cover" :src="item" :alt="item" />
                          </el-carousel-item>
                        </el-carousel>
                        <img v-else class="w-100 h-100" style="object-fit: cover" src="@/assets/images/no-img.png" :alt="item" />
                      </div>
                    </div>  
                    </div>
                  </div>

                  <div class="col-xl-7">
                    <div class="mt-3">
                      <h6 class="mt-1 mb-3 text-primary"><b>{{ dataProduct.metaSearchable.category }}</b></h6>
                      <h4 class="mt-1 mb-3"><b>{{ dataProduct.name }}</b></h4>
                      <h5 class="mb-4">
                        <b class="text-danger" style="font-weight: 600;font-size: 24px;line-height: 32px;">{{ dataVariationMin.prices[0].amount | formatMoney }}</b>
                      </h5>
                      <div class="_pdi-group-content" v-for="(option, i) in dataProduct.options" :key="i">
                      <div class="_pdi-group-title">{{ option.name }}</div>
                      <div class="_pdi-group-prop">
                        <span v-for="(value, i) in option.valuesArr" :key="i">{{ value.name }}</span >
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- end row -->

                <div class="mt-5">
                  <h5 class="mb-3"><b>Thông tin sản phẩm</b></h5>

                  <div class="table-responsive">
                    <table class="table mb-0 table-bordered">
                      <tbody>
                        <tr>
                          <th scope="row" style="width: 400px;">Mô tả</th>
                          <td><div v-html="dataProduct.description"></div></td>
                        </tr>
                        <tr>
                          <th scope="row" style="width: 400px;">Nhà sản xuất</th>
                          <td>{{ dataProduct.metaSearchable.madeBy }}</td>
                        </tr>
                        <tr>
                          <th scope="row" style="width: 400px;">Nhãn hiệu</th>
                          <td> {{ dataProduct.metaSearchable.brand }} </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!-- end Specifications -->

              </div>
            </div>
            <!-- end card -->
          </div>
        </div>
      </div>
    </div>
    <NotPermission v-else></NotPermission>
  </TheLayout>
</template>
<style lang="scss" scoped>
  ._product-sm-img {
  display: flex;
  flex-direction: column;
  max-height: 480px;
  overflow: hidden;

  &:hover {
    overflow: overlay;
  }

  &::-webkit-scrollbar {
    width: 4px;
    height: 4px; 
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: rgb(184, 184, 184);
    max-height: 50px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgb(163, 163, 163);
  }

  span {
    display: block;
    margin-bottom: 16px;

    img {
      width: 60px;
      height: 60px;
      display: inline-block;
      border-radius: 5px;
      object-fit: cover;
      border: 2px solid transparent;
    }
    img.active {
      border-color: #3E69F6;
    }
  }
}
  ._pdi-group-title {
    width: 25%;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #808890;
    text-transform: capitalize;
    margin-left: 10px;
  }
  ._pdi-group-content {
    flex-direction: column;
    margin-bottom: 10px !important;
    align-items: flex-start !important;
  }
  ._pdi-group-prop {
    margin: 15px 0;
    span {
      color: #23313e;
      border-radius: 4px;
      border: 1px solid #3e69f6;
      margin: 10px;
      padding: 5px 10px;
      cursor: pointer;
      background: #fff;
    }
  }
</style>